import { useCallback, useRef, useState } from 'react';

import { ProductResponse } from '@/providers/HttpProvider/Fulfill/Inventory/types';

const useInventoryPage = () => {
  const [productsSelected, setProductsSelected] = useState<ProductResponse['products']>([]);
  const [activeSkuCount, setActiveSkuCount] = useState<number | null>(null);
  const getProductsRef = useRef<(() => Promise<void>) | null>(null);

  const handleProductsSelected = useCallback((products: ProductResponse['products']) => {
    setProductsSelected(products);
  }, []);

  const handleInventoryUpdated = useCallback((getProducts: () => Promise<void>) => {
    getProductsRef.current = getProducts;
  }, []);

  const refreshInventory = useCallback(async () => {
    if (getProductsRef.current) {
      await getProductsRef.current();
    }
  }, []);

  const handleActiveSkuCount = useCallback((count: number) => {
    setActiveSkuCount(count);
  }, []);

  return {
    productsSelected,
    handleProductsSelected,
    handleInventoryUpdated,
    refreshInventory,
    activeSkuCount,
    handleActiveSkuCount,
  };
};

export default useInventoryPage;
